import { useState } from 'react'
import type { BlockProps } from '../types.js'
import { SectionWrapper } from './SectionWrapper.js'
import { RsvpFormModal } from './RsvpFormModal.js'
import styles from './common.module.css'

export function RsvpBlock({ invitation, activeSection, onSectionClick, mode }: BlockProps) {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <SectionWrapper
      sectionId="rsvp"
      activeSection={activeSection}
      onSectionClick={onSectionClick}
      mode={mode}
      className={styles.section}
    >
      <button
        type="button"
        className={styles.rsvpButton}
        onClick={mode === 'viewer' ? () => setModalOpen(true) : undefined}
        style={mode === 'viewer' ? { cursor: 'pointer' } : undefined}
      >
        참석 여부 알려주기
      </button>
      {mode === 'viewer' && (
        <RsvpFormModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          invitationId={invitation.id}
          rsvpFields={invitation.settings?.rsvpFields}
        />
      )}
    </SectionWrapper>
  )
}
